module.exports = __webpack_public_path__ + "static/img/17.2e3f796.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/17.png
// module id = U7HS
// module chunks = 0